// Author thq
// Date 2021-06-09 10:13:08

import * as model from "@/model/em/accident/EmAcctLevelModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmAcctLevel(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ACCIDENT_URL,
    })
    .buildStore()
